import { action, makeObservable, observable } from "mobx";
import { IPromiseBasedObservable, fromPromise } from "mobx-utils";
import {
  DoctorApi,
  CreateDoctorDto,
  SearchDoctorDto,
  CreateDoctorClinicDto,
} from "../../api-client";
import AuthStore from "../Auth/authStore";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import axios from "axios";

export default class DoctorStore {
  public apiClient: DoctorApi;
  public authStore: AuthStore;

  public constructor(apiClient: DoctorApi, authStore: AuthStore) {
    makeObservable(this);
    this.apiClient = apiClient;
    this.authStore = authStore;
    // this.getAllDoctors(); // Call the initialization method
  }
  // @observable
  // public doctorOptions: CreateDoctorDto[] = [];
  // @observable
  // public clinicOptions: any[] = [];

  // @action
  // public setDoctorOptions = (options: CreateDoctorDto[]) => {
  //   this.doctorOptions = options;
  // };
  // @action
  // public setClinicOptions = (options: any[]) => {
  //   // Action to set clinic data
  //   this.clinicOptions = options;
  // };
  public resourceRequest: IPromiseBasedObservable<any> | null = null;

  // @observable
  // public updatedDoctor: CreateDoctorDto | null = null;

  // @action
  // public setUpdatedDoctor = (doctor: CreateDoctorDto | null) => {
  //   this.updatedDoctor = doctor;
  //   console.log('UPDATAEDDDOCTOR',this.updatedDoctor?.number)
  // };

  public addUpdateDoctor = async (body: CreateDoctorDto) => {
    try {
      const { data } = (await this.apiClient.addUpdateDoctor(body)) as any;
      // this.setDoctorOptions(data.data || []);
      // console.log("doctorll", this.doctorOptions, data);
      // this.setUpdatedDoctor(data.saved); // Set the updated doctor
      return data.saved || [];
    } catch (error) {
      this.resourceRequest = fromPromise.reject(error);
    }
  };

  // @action
  // public getAllDoctors = async () => {
  //   const { data } = (await this.apiClient.getAllDOctorList(1, 10)) as any;
  //   // this.setDoctorOptions(data || []);
  //   this.setDoctorOptions(data?.data || []);

  //   console.log("doctorl45", this.doctorOptions);
  //   console.log("Dataui", data);
  //   return data?.data || [];
  // };

  //still needed for doctor.tsx
  public searchDoctor = async (page: number = 1, limit: number = 10, body: SearchDoctorDto) => {
    const authToken = this.authStore.authToken;
    const options: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    try {
      const { data } = (await this.apiClient.searchDoctor(body, page, limit, options)) as any;
      return data || [];
    } catch (error) {
      this.resourceRequest = fromPromise.reject(error);
    }
  };

  public getAllClinics = async (page: number = 1, limit: number = 10) => {
    const authToken = this.authStore.authToken;
    const options: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    try {
      const { data } = (await this.apiClient.doctorControllerFindAllClinics(JSON.stringify(page), JSON.stringify(limit))) as any;
      // this.setClinicOptions(data.data || []); // Store the fetched clinic data
      return data || [];
    } catch (error) {
      this.resourceRequest = fromPromise.reject(error);
      console.error("Error fetching clinic data:", error);
      return [];
    }
  };

  public getClinicById = async (clinicId: string) => {
    // const authToken = this.authStore.authToken;
    // const options: AxiosRequestConfig = {
    //   headers: {
    //     Authorization: `Bearer ${authToken}`,
    //   },
    // };

    try {
      // Call the API method, await the response and extract the data.
      const { data } = await this.apiClient.doctorControllerGetClinicById(clinicId);
      // console.log("Clinic Data:", data);
      return data || null;
    } catch (error) {
      this.resourceRequest = fromPromise.reject(error);
      console.error("Error fetching clinic data:", error);
      return null;
    }
  };

  public createDoctorWithClinic = async (createDoctorClinicDto: CreateDoctorClinicDto) => {
    try {
      const { data } = await this.apiClient.doctorControllerCreateDoctorWithClinic(
        createDoctorClinicDto
      );
      // if (!Array.isArray(this.doctorOptions)) {
      //   this.doctorOptions = []; // Initialize as empty array if needed
      // }
      // this.setDoctorOptions([...(this.doctorOptions || []), data as CreateDoctorDto]);
      return data;
    } catch (error) {
      this.resourceRequest = fromPromise.reject(error);
      console.error("Error creating doctor with clinic:", error);
      throw error;
    }
  };


  public getDoctorById = async (doctorId: string) => {
    const authToken = this.authStore.authToken;
    const options: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };

    try {
      // Call the API method, await the response and extract the data.
      const { data } = await this.apiClient.doctorControllerGetDoctorById(doctorId, options);
      // console.log("Doctor Data:", data);
      return data || null;
    } catch (error) {
      this.resourceRequest = fromPromise.reject(error);
      console.error("Error fetching Doctor data:", error);
      return null;
    }
  };

  public removeDoctorFromClinic = async (doctorId: string, clinicId: string) => {
    try {
      const authToken = this.authStore.authToken;
      const options: AxiosRequestConfig = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };

      await this.apiClient.doctorControllerRemoveDoctorFromClinic(doctorId, clinicId, options);

      // Update local state by filtering out the removed doctor
      // this.doctorOptions = this.doctorOptions.filter((doctor) => doctor.id !== doctorId);

      // console.log(`Doctor with ID ${doctorId} removed from Clinic ID ${clinicId}`);
      return `Doctor with ID ${doctorId} removed from Clinic ID ${clinicId}`;
    } catch (error) {
      this.resourceRequest = fromPromise.reject(error);
      console.error("Failed to remove doctor from clinic:", error);
      return "Failed to remove doctor from clinic.";
    }
  };


  public updateClinic = async (
    clinicId: string,
    updateClinicDto: Partial<CreateDoctorClinicDto>
  ) => {
    try {
      const authToken = this.authStore.authToken;
      const options: AxiosRequestConfig = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      const { data } = await this.apiClient.doctorControllerUpdateClinic(
        clinicId,
        updateClinicDto,
        options
      );

      // If successful, update local state
      // if (data) {
      //   this.setClinicOptions(
      //     this.clinicOptions.map((clinic) =>
      //       clinic.id === clinicId ? { ...clinic, ...updateClinicDto } : clinic
      //     )
      //   );
      // }
      return data;
    } catch (error) {
      this.resourceRequest = fromPromise.reject(error);
      console.error("Error updating clinic:", error);
      throw error;
    }
  };

  public removeClinic = async (clinicId: string) => {
  try {
    await this.apiClient.doctorControllerRemoveClinic(clinicId);
    // Update local state by filtering out the removed clinic
    // this.clinicOptions = this.clinicOptions.filter((clinic) => clinic.id !== clinicId);
    // console.log(`Clinic with ID ${clinicId} removed successfully.`);
    return `Clinic with ID ${clinicId} removed successfully.`;
  } catch (error) {
    this.resourceRequest = fromPromise.reject(error);
    console.error("Failed to remove clinic:", error);
    return "Failed to remove clinic.";
  }
};

  public searchClinic = async (page: number = 1, limit: number = 10, body: SearchDoctorDto) => {
    const authToken = this.authStore.authToken;
    const options: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    try {
      const { data } = (await this.apiClient.searchClinic(body, page, limit, options)) as any;
      return data || [];
    } catch (error) {
      this.resourceRequest = fromPromise.reject(error);
    }
  };

  // ── ID Migration ────────────────────────────────────────────
  private get basePath() {
    return (this.apiClient as any).basePath || process.env.REACT_APP_API_URL || "";
  }

  private get authHeaders(): AxiosRequestConfig {
    return {
      headers: { Authorization: `Bearer ${this.authStore.authToken}` },
    };
  }

  /** Update a doctor's LANR and cascade to linked Rx rows. */
  public updateDoctorLANR = async (doctorId: string, newLANR: string) => {
    const { data } = await axios.patch(
      `${this.basePath}/doctor/${encodeURIComponent(doctorId)}/lanr`,
      { newLANR },
      this.authHeaders
    );
    return data;
  };

  /** Preflight: count Rx rows that would be re-linked when this doctor's LANR is changed */
  public countAffectedRxsForDoctor = async (doctorId: string): Promise<number> => {
    const { data } = await axios.get(
      `${this.basePath}/doctor/${encodeURIComponent(doctorId)}/affected-rxs/count`,
      this.authHeaders
    );
    return Number(data?.count ?? 0);
  };

  /** Update a clinic's BSNR and cascade to linked Rx rows */
  public updateClinicBSNR = async (clinicId: string, newBSNR: string) => {
    const { data } = await axios.patch(
      `${this.basePath}/doctor/clinic/${encodeURIComponent(clinicId)}/bsnr`,
      { newBSNR },
      this.authHeaders
    );
    return data;
  };

  /** Preflight: count Rx rows that would be re-linked when this clinic's BSNR is changed */
  public countAffectedRxsForClinic = async (clinicId: string): Promise<number> => {
    const { data } = await axios.get(
      `${this.basePath}/doctor/clinic/${encodeURIComponent(clinicId)}/affected-rxs/count`,
      this.authHeaders
    );
    return Number(data?.count ?? 0);
  };

  /**
   * Merge a duplicate doctor (source) into another (target). Moves all Rxs,
   * tickets and clinic assignments from the source to the target, applies the
   * finalized field values, then deletes the source. No Rx is ever deleted.
   */
  public mergeDoctors = async (payload: {
    targetId: string;
    sourceId: string;
    updatedTarget?: { LANR?: string; contactInfo?: Record<string, unknown> };
  }) => {
    const { data } = await axios.post(
      `${this.basePath}/doctor/merge`,
      payload,
      this.authHeaders
    );
    return data;
  };

  /**
   * Merge a duplicate clinic (source) into another (target). Moves all Rxs,
   * tickets and doctor assignments from the source to the target, applies the
   * finalized field values, then deletes the source. No Rx is ever deleted.
   */
  public mergeClinics = async (payload: {
    targetId: string;
    sourceId: string;
    updatedTarget?: { BSNR?: string; notes?: string; contactInfo?: Record<string, unknown> };
  }) => {
    const { data } = await axios.post(
      `${this.basePath}/doctor/clinic/merge`,
      payload,
      this.authHeaders
    );
    return data;
  };

  public toggleAssignmentActive = async (assignmentId: string, isActive: boolean) => {
    const { data } = await axios.patch(
      `${this.basePath}/doctor/assignment/${encodeURIComponent(assignmentId)}/active`,
      { isActive },
      this.authHeaders
    );
    return data;
  };

}
